import {
  z,
  type ZodString,
} from 'zod';

import {
  type WithRequired,
} from '@specia-accountant/shared';

export const clientSchema = z.object({
  id: z.string(),
  clientname: z.string(),
  clientabn: z.string(),
  ssid: z.string(),
  adminemails: z.array<ZodString>(
    z.string().email(),
  ),
  financial_sw_account: z.string(),
  financial_sw_type: z.string(),
  agentemails: z.array<ZodString>(
    z.string().email(),
  ),
  status: z.enum([
    'done',
    'ctlreq',
    'processing',
    'failed',
  ]),
  status_detail: z.string(),
});

export type Client = z.infer<typeof clientSchema>;
export type ClientWithId = WithRequired<Client, 'id'>;
export interface ClientParsed extends Omit<ClientWithId, 'status'> {
  status: 'Active' | 'Pending' | 'Fail';
}

export interface ClientsApiResponse {
  data: Array<ClientWithId>;
  meta?: {
    totalRowCount: number;
  };
};

export interface ClientsApiResponseParsed extends Omit<ClientsApiResponse, 'data'> {
  data: Array<ClientParsed>;
};

export const parseClient = (client: ClientWithId): ClientParsed => {
  let status: ClientParsed['status'];
  switch (client.status) {
    case 'done': {
      status = 'Active';
      break;
    }
    case 'ctlreq': {
      status = 'Pending';
      break;
    }
    case 'processing': {
      status = 'Pending';
      break;
    }
    default: {
      status = 'Fail';
      break;
    }
  }
  return {
    ...client,
    status,
  };
};

export async function parseClientsApiResponse(
  res: Promise<ClientWithId[]>,
): Promise<ClientsApiResponseParsed> {
  const clientsData = (await res).map(parseClient);
  return {
    data: clientsData,
    meta: {
      totalRowCount: clientsData.length,
    },
  };
}
